import { render } from "./RealEstateAssetDetail.vue?vue&type=template&id=2fec008a&scoped=true"
import script from "./RealEstateAssetDetail.vue?vue&type=script&lang=ts"
export * from "./RealEstateAssetDetail.vue?vue&type=script&lang=ts"

import "./RealEstateAssetDetail.vue?vue&type=style&index=0&id=2fec008a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2fec008a"

export default script